import * as Yup from "yup"

import type { AppLocalization } from "../../../modules/localization/appLocalization"

import { isIntegerRange, type NumericRange } from "./numericFieldTypes"

type L10n = Pick<AppLocalization, "getString">

export function numericFieldSchema(
    range: NumericRange,
    l10n: L10n,
    label: string,
): Yup.NumberSchema<number | null | undefined> {
    let schema = Yup.number().nullable().typeError(l10n.getString("numeric-field-invalid-error", { label }))

    if (isIntegerRange(range)) {
        schema = schema.integer(l10n.getString("numeric-field-integer-error", { label }))
    }

    switch (range) {
        case "positive-integer":
        case "positive-decimal":
            return schema.positive(l10n.getString("numeric-field-positive-error", { label }))
        case "non-negative-integer":
        case "non-negative-decimal":
            return schema.min(0, l10n.getString("numeric-field-non-negative-error", { label }))
        case "negative-integer":
        case "negative-decimal":
            return schema.negative(l10n.getString("numeric-field-negative-error", { label }))
        case "non-positive-integer":
        case "non-positive-decimal":
            return schema.max(0, l10n.getString("numeric-field-non-positive-error", { label }))
        case "integer":
        case "decimal":
            return schema
    }
}
